export default "/_next/static/videos/1ca589091e1376fbb83ef947820928be.mp4";